import ModalWrapper from '@/components/Modals/ModalWrapper/ModalWrapper';
import { icons } from '@/Icons';
import { socialLinks } from './data';

const GeoBlockModal = () => {
	return (
		<ModalWrapper onClose={() => {}} disableClose={true}>
			<div
				className="bg-midnight-blue w-screen md:max-w-[660px] h-fit mb-0 m-auto max-h-[750px] p-16 px-5 md:px-16 md:m-auto flex rounded-[10px] flex-col items-center gap-8 popup overflow-hidden"
				style={{
					boxShadow: '0px 5px 30px 0px rgba(0, 0, 0, 0.60)',
				}}
			>
				<icons.mainlogoletters className="max-w-[246.5px] max-h-[45.6px]" />
				<div className="flex flex-col gap-4 items-center text-center">
					<p className="text-[25px] font-extrabold ">
						Otherworld.xyz is not available in your region
					</p>
					<p className="max-w-[430px]">
						Due to licensing restrictions, we cannot accept players from your
						country. If you’re using a VPN, please disable it and try again.
					</p>
				</div>
				<div className="flex gap-8">
					{socialLinks.map((link) => (
						<a
							key={link.title}
							href={link.href}
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center justify-center"
						>
							<span className="w-6 h-6">{link.icon}</span>
						</a>
					))}
				</div>
			</div>
		</ModalWrapper>
	);
};

export default GeoBlockModal;
